import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useSubCategoriesDocumentDetails } from "./FooterLogo.hook";

const AddEditFooterLogo = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editSubCategories,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchSubCategories,
  } = useSubCategoriesDocumentDetails(query.get("editId") || "");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchSubCategories();
    }
  }, [query.get("editId"), query.get("id")]);

  //  const epcApplicationsFormConfig: FormConfig = {
  //   initialValues: {
  //     name: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.name)
  //       : decodeHTML(editSubCategories?.name),
  //     link: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.link)
  //       : decodeHTML(editSubCategories?.link),
  //     name_ms: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.name_ms)
  //       : decodeHTML(editSubCategories?.name_ms),
  //     name_zh: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.name_zh)
  //       : decodeHTML(editSubCategories?.name_zh),
  //     isSocialMedia: editSubCategoriesById?.payload
  //       ? editSubCategoriesById?.payload?.isSocialMedia
  //       : editSubCategories?.isSocialMedia,
  //     image: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.image)
  //       : decodeHTML(editSubCategories?.image),
  //     published: editSubCategoriesById?.payload
  //       ? editSubCategoriesById?.payload?.published
  //       : editSubCategories?.published,
  //   },
  //   fields: fields.footers,
  // };

  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      name: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.name)
        : decodeHTML(editSubCategories?.name),
      link: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.link)
        : decodeHTML(editSubCategories?.link),
      name_ms: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.name_ms)
        : decodeHTML(editSubCategories?.name_ms),
      name_zh: editSubCategoriesById?.payload
        ? decodeHTML(editSubCategoriesById?.payload?.name_zh)
        : decodeHTML(editSubCategories?.name_zh),
      isSocialMedia: editSubCategoriesById?.payload
        ? editSubCategoriesById?.payload?.isSocialMedia
        : editSubCategories?.isSocialMedia,
      image: editSubCategoriesById?.payload?.image
        ? [
            {
              uid: "-1",
              name: "image.jpg",
              status: "done",
              url: decodeHTML(editSubCategoriesById?.payload?.image),
            },
          ]
        : editSubCategories?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: decodeHTML(editSubCategories?.image),
              },
            ]
          : [],
      published: editSubCategoriesById?.payload
        ? editSubCategoriesById?.payload?.published
        : editSubCategories?.published,
    },
    fields: fields.footers,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    // console.log("hariomfff", data);
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (Array.isArray(field) && field.length > 0) {
          const fileItem = field[0];

          if (fileItem.originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", fileItem.originFileObj);
            formData.append("application", "PASSENGER");
            const res: any = await post("management/upload-file", formData);

            if (res?.response?.data) {
              data[key] = res.response.data;
            } else {
              data[key] = "";
            }
          } else if (fileItem.url) {
            data[key] = fileItem.url;
          } else {
            data[key] = "";
          }
        } else {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Footer",
      subModule: "footers",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editSubCategories?.id || editSubCategoriesById?.payload?.id }),
        ...data,
        // field_sub_categories_status: true,
        // field_sub_created_at: "2023-11-21T10:01:09",
        // field_sub_updated_at: "2025-11-29T10:01:09"
      },
      status: status,
    };

    console.log(payload, "tested");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingSubCategories}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Footer`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingSubCategories || drilldownLoading}
        config={epcApplicationsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${passengerHost}/api/create-webapp-footer-logos-taxonomy-crud-api-data/${editSubCategories?.id || editSubCategoriesById?.payload?.id}` : `${passengerHost}/api/create-webapp-footer-logos-taxonomy-crud-api-data`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Footer"
      />
    </ContentWrapper>
  );
};

export default AddEditFooterLogo;
